import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { MwSharedLibsModule } from './shared-libs.module';

@NgModule({
  imports: [MwSharedLibsModule],
  declarations: [],
  exports: [MwSharedLibsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MwSharedModule {
  static forRoot(): ModuleWithProviders<MwSharedModule> {
    return {
      ngModule: MwSharedModule,
    };
  }
}
